module.exports = __webpack_public_path__ + "static/img/light.2558e25.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pumpMonitor/img/light.png
// module id = fT1A
// module chunks = 163